import { render, staticRenderFns } from "./ModalSuccessTransference.vue?vue&type=template&id=39d7e600&scoped=true"
import script from "./ModalSuccessTransference.vue?vue&type=script&lang=js"
export * from "./ModalSuccessTransference.vue?vue&type=script&lang=js"
import style0 from "./ModalSuccessTransference.vue?vue&type=style&index=0&id=39d7e600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7e600",
  null
  
)

export default component.exports